/* eslint-disable react/jsx-filename-extension */
import React from 'react';

const airAppChangeLogStatic = [
  {
    version: '2.7.2',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          This firmware update includes under the hood improvements to how Mila processes air quality data and a bug fix.
        </p>
        <p><strong>Bug Fixes:</strong></p>
        <ul>
          <li>
            AQI readings stuck at 999: Addressed an issue where a small number of Milas were occasionally showing a maxed-out AQI of 999.
          </li>
        </ul>
      </>
    ),
  },
  {
    version: '2.7.1',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>Improvements:</strong>
        </p>
        <ul>
          <li>
            <strong> Updated sensor calibrations:</strong>
            {' '}
            We've refined how Mila interprets sensor data to help smooth out occasional spikes. You shouldn't notice any changes in the app.
          </li>
        </ul>
        <p>
          <strong>Bug Fixes:</strong>
        </p>
        <ul>
          <li>
            <strong> Improved mode transitions:</strong>
            {' '}
            Fixed a bug where Couch Potato mode could occasionally interfere with Turndown Service. Smart modes should now transition more reliably.
          </li>

        </ul>
      </>
    ),
  },
  {
    version: '2.7',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>Improvements:</strong>
        </p>
        <ul>
          <li>
            <strong> Updated sensor calibrations:</strong>
            {' '}
            We've refined how Mila interprets sensor data to help smooth out occasional spikes. You shouldn't notice any changes in the app.
          </li>
        </ul>
        <p>
          <strong>Bug Fixes:</strong>
        </p>
        <ul>
          <li>
            <strong> Improved mode transitions:</strong>
            {' '}
            Fixed a bug where Couch Potato mode could occasionally interfere with Turndown Service. Smart modes should now transition more reliably.
          </li>

        </ul>
      </>
    ),
  },
  {
    version: '2.7',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          This firmware update lays the groundwork for Performance Profiles in your Mila app and improves how your Mila runs day-to-day. Applies to both Air and Air Mini.
        </p>
        <p>
          <strong>What’s New:</strong>
        </p>
        <ul>
          <li>
            <strong>Performance Profiles support:</strong>
            {' '}
            Adds the on-device engine that helps your room hit a daily air exchange target.
          </li>
          <li>
            <strong>Smarter restart behavior:</strong>
            {' '}
            Mila now remembers your last settings after any reboot, so you can pick up right where you left off (e.g., if you had it set at 10% on Manual mode, it’ll restart there).
          </li>
        </ul>
        <p>
          <strong>Improvements:</strong>
        </p>
        <ul>
          <li>
            <strong>More reliable app ↔ device sync:</strong>
            {' '}
            Mode and fan speed selections now stay aligned more consistently between the app and your Mila.
            {' '}
          </li>
          <li>
            <strong>More accurate fan speed reporting:</strong>
            {' '}
            Fan speed is now reported as a consistent percentage, allowing for more consistency across Mila models.
          </li>
          <li>
            <strong>More consistent progress updates:</strong>
            {' '}
            Progress and timeline stats now refresh every 15 minutes
          </li>
        </ul>
        <p>
          <strong>Bug Fixes:</strong>
        </p>
        <ul>
          <li>
            Fixed an issue where very long Sleep schedules (18+ hours) could end early.

          </li>

          <li>
            Fixed cases where a selected setting didn’t apply on the device and the fan looked “stuck.”
          </li>
        </ul>
      </>
    ),
  },
  {
    version: '2.6.3',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>What’s New:</strong>
        </p>
        <ul>
          <li>
            Holiday Easter Eggs: Keep an eye out for some seasonal cheer and
            festive surprises
          </li>
        </ul>
        <p>
          <strong>Bug Fixes: </strong>
        </p>
        <ul>
          <li>
            Fixed an issue where Sleep Mode turned off early on long schedules
            (18+ hours).
          </li>
        </ul>
      </>
    ),
  },
  {
    version: '2.6.0',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          This firmware update lays the groundwork for some exciting new app
          features and improves how your Mila runs day-to-day.
        </p>
        <p>
          <strong>What’s New </strong>
        </p>
        <ul>
          <li>
            <strong>Morning Routine Support:</strong>
            {' '}
            Adds backend support for a
            new Morning Routine feature in the app, allowing your Mila to turn
            on automatically before your scheduled wake-up time.
          </li>
        </ul>
        <p>
          <strong>Improvements</strong>
        </p>
        <ul>
          <li>
            General performance enhancements and optimizations to keep things
            running smoothly.
          </li>
        </ul>
      </>
    ),
  },

  {
    version: '2.5.0',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>What’s New: </strong>
        </p>
        <ul>
          <li>
            <strong>Faster, quieter startup.</strong>
            {' '}
            We removed the calibration
            step that used to run every time Mila powered on. Now, Mila skips
            the fan ramp-up and jumps straight into purifying—so there’s less
            noise and fewer interruptions. Mila’s sensors will continue to
            calibrate automatically as needed to keep performance top- notch.
            And if you ever want to recalibrate manually (like after a big
            move), you can still do that through the app.
          </li>
        </ul>
        <p>
          <strong>Improvements and Bug Fixes:</strong>
        </p>
        <ul>
          <li>
            {' '}
            We fixed a bug affecting some Mila Airs that caused sudden spikes in
            VOC and CO2 readings.
          </li>
          <li>
            We previously saw a few cases where Mila’s fan would stay at 20%
            speed even when the AQI was at 0. This was tied to a recent firmware
            update and has since been addressed.
          </li>
        </ul>
      </>
    ),
  },
  {
    version: '2.4.0',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>Improvements and bug fixes: </strong>
        </p>
        <ul>
          <li>
            Touchscreen Improvements: We’ve improved touch sensitivity and fixed
            an issue where the touchscreen sometimes failed to initialize on
            bootup.
          </li>
          <li>
            Adjusted Alert Thresholds: Updates to VOC, CO2, humidity, and mold
            thresholds to make alerts more actionable and reduce false
            positives.
          </li>
        </ul>
      </>
    ),
  },
  {
    version: '2.3.1',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>New Features and Improvements:</strong>
        </p>
        <ul>
          <li>Improved sensor alert thresholds</li>
        </ul>
      </>
    ),
  },
  {
    version: '2.3.0',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>What’s New:</strong>
        </p>
        <ul>
          <li>
            <strong>Holiday Easter Eggs 😏:</strong>
            {' '}
            Keep an eye out for some
            seasonal cheer and festive surprises
          </li>
          <li>
            <strong> Brightness Tweaks:</strong>
            {' '}
            Daytime brightness is now set
            to 100%, while nighttime dims to a cozy 30%.
          </li>
          <li>
            <strong>Boot-Up Chime Update:</strong>
            {' '}
            Mila stays silent during
            Sleep or Whitenoise Mode, ensuring no disruptions during quiet
            hours.
          </li>
          <li>
            <strong>Display Improvements:</strong>
            {' '}
            Experience more responsive
            touch interactions
          </li>
        </ul>
      </>
    ),
  },
  {
    version: '2.2.0',
    time: null,
    prettyTime: null,
    description: (
      <>
        <p>
          <strong>Bug Fixes</strong>
        </p>
        <ul>
          <li>
            Fixed a time synchronization issue that could cause Mila’s schedules
            to fall out of sync if it couldn’t connect to the Internet
            immediately after restarting.
          </li>
          <li>
            Fixed random crashes that some users experienced due to HomeKit
            interactions on certain networks.
          </li>
        </ul>
      </>
    ),
  },
];

export default airAppChangeLogStatic;
